/**
 * Pure helpers for invoice deletion with Admin approval (BUG-006): who approves, the open request of a row, its API
 * path and the "Deletion requested · <name>" text. The menus, dialogs and the hook are in ./invoiceDeletion.js.
 */
import { formatDate } from '@/lib/format';

export const APPROVER_ROLES = ['Admin', 'Super Admin'];
export const MAX_REASON = 500;

const text = (value) => String(value ?? '').trim();

/** Admin / Super Admin: approve, reject, and delete at once. */
export const isApprover = (user) => APPROVER_ROLES.includes(text(user?.role));

/** The open deletion request of an invoice ({ id, requested_by_id, requested_by_name, requested_at, reason }) or null. */
export function deletionRequestOf(invoice) {
  const request = invoice?.deletion_request;
  return request && typeof request === 'object' && request.id ? request : null;
}

/** A VO invoice (variation_id, or a register row of kind 'vo') lives under /variation-invoices. */
export const isVariationInvoice = (invoice, kind) => kind === 'vo' || Boolean(text(invoice?.variation_id));
export const invoiceApiPath = (invoice, kind) => `${isVariationInvoice(invoice, kind) ? '/variation-invoices' : '/invoices'}/${invoice.id}`;

/** "invoice 275" / "the Installation payment" — how a person recognises the row. */
export function invoiceLabel(invoice) {
  if (text(invoice?.reference)) return `invoice ${text(invoice.reference)}`;
  return `the ${text(invoice?.invoice_type) || 'scheduled'} payment`;
}

/** "Deletion requested · Mona Presales" (+ when and why in the tooltip). */
export function deletionPillText(request) {
  return `Deletion requested · ${text(request?.requested_by_name) || 'someone'}`;
}
export function deletionPillTitle(request) {
  if (!request) return '';
  const when = request.requested_at ? ` on ${formatDate(request.requested_at)}` : '';
  const why = text(request.reason) ? ` — “${text(request.reason)}”` : '';
  return `${text(request.requested_by_name) || 'Someone'} asked to delete it${when}${why}. It stays in the totals until an admin approves.`;
}
